const STORAGE_KEY = "fp:presence:client-id";
let memoryClientId = "";

const createClientId = () => {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch {}
  return `presence-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
};

export const getPresenceClientId = () => {
  if (memoryClientId) return memoryClientId;
  try {
    const existing = String(sessionStorage.getItem(STORAGE_KEY) || "").trim();
    if (existing) {
      memoryClientId = existing;
      return memoryClientId;
    }
  } catch {}

  memoryClientId = createClientId();
  try { sessionStorage.setItem(STORAGE_KEY, memoryClientId); } catch {}
  return memoryClientId;
};
